import { useContext, createContext, useState } from "react";

const SearchContext = createContext();
export function useSearchContext(){
    return useContext(SearchContext);
} 

export default function SearchProvider({children}){
    const [searchStr, setSearchStr] = useState('');
    return <SearchContext.Provider
        value={{
            searchStr,
            setSearchStr
        }}
    >
        {children}
    </SearchContext.Provider>;
}